
import {Controller} from "@hotwired/stimulus"
import * as Ladda from "ladda"

class LaddaController extends Controller {
  connect() {
    Ladda.bind(this.element)
  }

  disconnect() {
    this.stop()
  }

  stop() {
    Ladda.create(this.element).stop()
  }
}

export default LaddaController
